import  { useState, useEffect, Fragment } from "react";
import axios from "axios";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import SearchIcon from '@mui/icons-material/Search';
import InquiriesMobile from "./InquiriesMobile";
import isDesktop from "../isDesktop";
import styles from './Inquiries.module.css';
import { useLocalStorage } from "@uidotdev/usehooks";
import { ArrowBackIosNewRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Button, Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import { hasStoredTabAccess } from '../utils/access';

const responseOptions = ['Phone', 'Email', 'Message'];

const Inquiries = () => {
  const isDesktopDevice = isDesktop();
  const [inquiries, setInquiries] = useState([]);
  const [filteredInquiries, setFilteredInquiries] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [responseInputs, setResponseInputs] = useState({
    index: null, // index of the row being edited
    respondedThrough: '',
    respondedOn: '',
    respondedBy: '',
    remark: '',
  });
  const isAuthorized = hasStoredTabAccess('Enquiries');
  const navigate=useNavigate()
  // eslint-disable-next-line no-unused-vars
  const [token, setToken] = useLocalStorage('token', null);
  const empId = localStorage.getItem('userId');

  function formatDateAndTime(date) {
    date = new Date(date);
    let ISTDate = new Date(date.getTime());

    let day = ISTDate.getDate();
    let month = ISTDate.getMonth() + 1;
    let year = ISTDate.getFullYear();

    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;
    let formattedDate = `${day}.${month}.${year}`;

    // Format the time in HH.MM am/pm
    let hours = ISTDate.getHours();
    let minutes = ISTDate.getMinutes();
    let AmOrPm = hours >= 12 ? 'pm' : 'am';
    hours = (hours % 12) || 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let formattedTime = `${hours}:${minutes}${AmOrPm}`;
    return { time: formattedTime, date: formattedDate };
  }

  const fetchInquiries = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/contact-us`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const sortedData = response.data.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setInquiries(sortedData);
        setFilteredInquiries(sortedData);
      } else {
        console.error("Error fetching inquiries: ", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching inquiries: ", error);
    }
  };
  useEffect(() => {
    isDesktopDevice && fetchInquiries();
  }, [isDesktopDevice]);

  useEffect(() => {
    isDesktopDevice && applyFilters();
  }, [searchQuery, fromDate, toDate]);

  const applyFilters = () => {
    const filteredData = inquiries.filter((inquiry) => {
      const { name, email, phone, created_at } = inquiry;
      const query = searchQuery.toLowerCase();
      const inquiryDate = new Date(created_at);
      const isWithinDateRange =
        (!fromDate || inquiryDate >= new Date(fromDate)) &&
        (!toDate || inquiryDate <= new Date(toDate));
      return (
        (name.toLowerCase().includes(query) ||
          email.toLowerCase().includes(query) ||
          phone.toLowerCase().includes(query)) &&
        isWithinDateRange
      );
    });

    setFilteredInquiries(filteredData);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleFromDateChange = (e) => {
    setFromDate(e.target.value);
  };

  const handleToDateChange = (e) => {
    setToDate(e.target.value);
  };

  const handleSaveEnquiries = async () => {
    if(!responseInputs.respondedThrough || !responseInputs.respondedOn || !responseInputs.respondedBy) {
      toast.error("Please fill all the fields.");
      return;
    }
    const response = await axios.put(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/contact-us/update/${responseInputs.index}/${empId}`, responseInputs);
    if(response.status === 204) {
      toast.success("Response saved successfully.");
      fetchInquiries();
    } else {
      toast.error("Failed to save response.");
    }
  }
  
  const handleInputChange = (field, value, msg_id) => {
    setResponseInputs((prev) => ({
      ...prev,
      index: msg_id,
      [field]: value,
    }));
  };
  return (
    <>
      {
        isAuthorized ? (
          isDesktopDevice ? (
            <div className="container-fluid" style={{ paddingTop: '3.6vw' }}>
              <div className="align-center-all full-height">
                <Card elevation={3} className="col-md-12 p-3" style={{ boxShadow: 'none' }}>
                  <CardContent>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div
                style={{
                  display: "flex",
                  gap: "1vw",
                  alignItems: "center",
                }}
              >
                <ArrowBackIosNewRounded
                  onClick={() => {
                    navigate("/dashboard");
                  }}
                  style={{ cursor: "pointer" }}
                />
                <h2
                  style={{ marginRight: "1rem", marginBottom: "0px" }}
                  className="page-header"
                >
                  Enquiries
                </h2>
              </div>
                      <div className={styles.filterForm}>
                        <TextField
                          style={{ marginRight: "1vw" }}
                          value={searchQuery}
                          onChange={handleSearchChange}
                          variant="outlined"
                          placeholder="Search"
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: 'transparent',
                              },
                              '&:hover fieldset': {
                                borderColor: 'transparent',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: 'transparent',
                                boxShadow: 'none',
                              },
                            },
                          }}
                          InputProps={{
                            style: {
                              height: '2.564vw',
                              boxShadow: '0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A'
                            },
                            endAdornment: <SearchIcon />,
                          }}
                          margin="normal"
                        />
                        <TextField
                          label="From Date"
                          type="date"
                          value={fromDate}
                          onChange={handleFromDateChange}
                          InputProps={{ style: { height: '2.564vw' } }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          margin="normal"
                          style={{ marginRight: "1vw" }}
                        />
                        <TextField
                          label="To Date"
                          type="date"
                          value={toDate}
                          onChange={handleToDateChange}
                          InputProps={{ style: { height: '2.564vw' } }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          margin="normal"
                        />
                      </div>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-around', fontWeight: 'bold'}}>
                      <div>Enquiries</div>
                      <div>Response</div>
                    </div>
                    <table className="table">
                      <thead style={{ height: '44px', borderRadius: '4px !important', background: 'rgba(234, 241, 247, 1)', boxShadow: '2px 2px 4px 0px rgba(174, 174, 192, 0.5)' }}>
                        <tr>
                          <th className={styles.thfirstChild}>S. No.</th>
                          <th style={{ textAlign: 'left' }}>Name</th>
                          <th>Mobile</th>
                          <th>Date & Time</th>
                          <th>Responded Through</th>
                          <th>Responded on</th>
                          <th>Responded by</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredInquiries.map((inquiry, index) => (
                          <Fragment key={index}>
                          <tr key={inquiry.msg_id} className={styles.tdBorderBottomStyles}>
                            <td>{index + 1}</td>
                            <td style={{ textAlign: 'left' }}>
                              <>
                                <p className={styles.paraNoMarginPadding} style={{ padding: '0', margin: '0' }}>{inquiry.name}</p>
                                <p className={styles.paraNoMarginPadding} style={{ padding: '0', margin: '0' }}>{inquiry?.username}</p>
                              </>
                            </td>
                            <td>{inquiry.phone}</td>
                            <td>
                              <>
                                <p className={styles.paraNoMarginPadding}>{formatDateAndTime(inquiry.created_at).date}</p>
                                <p className={styles.paraNoMarginPadding}>{formatDateAndTime(inquiry.created_at).time}</p>
                              </>
                            </td>
                            <td>
                              <FormControl sx={{ m: 1, minWidth: 160 }} size="small">
                                <InputLabel
                                  id="responseTitle"
                                  sx={{ fontSize: "0.75rem" }}
                                >
                                  Responded Through
                                </InputLabel>
                                <Select
                                  labelId="responseTitle"
                                  id="respondedThrough"
                                  value={responseInputs.index === inquiry.msg_id ? responseInputs.respondedThrough : inquiry.respondedThrough || ''}
                                  onChange={(e) => handleInputChange('respondedThrough', e.target.value, inquiry.msg_id)}
                                  label="Responded Through"
                                  renderValue={(selected) => selected}
                                  size="small"
                                  sx={{ textAlign: 'left' }}
                                >
                                  {responseOptions.map((option) => (
                                    <MenuItem key={option} value={option}>
                                      <Checkbox checked={responseInputs.respondedThrough === option} />
                                      <ListItemText primary={option} />
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </td>
                            <td>
                              <TextField
                                label="Responded on"
                                type="date"
                                value={responseInputs.index === inquiry.msg_id ? responseInputs.respondedOn : (inquiry.updated_at !== inquiry.created_at && inquiry.updated_at.slice(0, 10)) || ''}
                                onChange={(e) => handleInputChange('respondedOn', e.target.value, inquiry.msg_id)}
                                InputProps={{ style: { height: '2.564vw' } }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                sx={{ margin: '0.5rem auto'}}
                              />
                            </td>
                            <td>
                              <TextField
                                size="small"
                                sx={{m: 1, minWidth: '9.75rem'}}
                                id="user"
                                type="text"
                                name="User"
                                label="Responded by"
                                fullWidth
                                value={responseInputs.index === inquiry.msg_id ? responseInputs.respondedBy : inquiry.respondedBy || ''}
                                onChange={(e) => handleInputChange('respondedBy', e.target.value, inquiry.msg_id)}
                                className={styles.inputs}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={1}></td>
                            <td colSpan={3} style={{textAlign: 'left'}}>
                              <div><span style={{fontWeight: 'bold'}}>Email: </span>{inquiry.email}</div>
                              <div><span style={{fontWeight: 'bold'}}>Message: </span>{inquiry.message}</div>
                            </td> {/* Skip first 4 columns */}
                            <td colSpan={3} style={{paddingRight: '0.1rem', paddingLeft: '2.9rem'}}>
                              <div style={{display: 'flex', gap: '1.5vw'}}>
                                <TextField
                                  fullWidth
                                  label="Comment"
                                  variant="outlined"
                                  size="small"
                                  value={responseInputs.index === inquiry.msg_id ? responseInputs.remark : inquiry.remark || ''}
                                  onChange={(e) => handleInputChange('remark', e.target.value, inquiry.msg_id)}
                                />
                                <Button 
                                  size="small" 
                                  className="filled-button"
                                  sx={{display: inquiry.remark && 'none'}}
                                  onClick={handleSaveEnquiries}
                                >Submit</Button>
                              </div>
                            </td>
                            </tr>
                          </Fragment>
                        ))}
                      </tbody>
                    </table>
                  </CardContent>
                </Card>
                <ToastContainer />
              </div>
            </div>
          ) : (
            <InquiriesMobile />
          ) 
        ) : (
          <h2 style={{marginTop: '5%'}}>You are unauthorized to access this page.</h2>
        )
    }
    </>
  );
};

export default Inquiries;